import type React from 'react'
import { useState } from 'react'
import AppInput from '../../../../components/atoms/AppInput/AppInput'
import AppButton from '../../../../components/atoms/AppButton/AppButton'

interface AddWarehouseFormProps {
    onClose: () => void
    onSubmit: (data: {
        warehouse: string
        ciudad: string
        direccion: string
    }) => void
}

const AddWarehouseForm = ({ onClose, onSubmit }: AddWarehouseFormProps) => {
    const [formData, setFormData] = useState({
        warehouse: '',
        ciudad: '',
        direccion: '',
    })

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target
        setFormData((prev) => ({ ...prev, [name]: value }))
    }

    const handleSubmit = () => {
        onSubmit(formData)
    }

    const isFormValid =
        formData.warehouse.trim() !== '' &&
        formData.ciudad.trim() !== '' &&
        formData.direccion.trim() !== ''

    return (
        <div className="relative z-10 bg-white rounded-lg shadow-lg w-full max-w-md p-6">
            {/* Header */}

            <div className="flex items-center justify-between pb-5">
                <h2 className="text-xl font-semibold text-gray-900">
                    Agregar warehouse
                </h2>
                <button
                    onClick={onClose}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </div>
            <div className="border-b absolute w-full left-0 top-16 mb"></div>

            {/* Form */}
            <div className="space-y-4 mt-6">
                {/* Warehouse Input */}
                <AppInput
                    label="Warehouse"
                    name="warehouse"
                    placeholder="Nombre"
                    value={formData.warehouse}
                    onChange={handleChange}
                    required
                />

                {/* Ciudad Select */}
                <AppInput
                    label="Ciudad"
                    name="ciudad"
                    placeholder="Ciudad"
                    value={formData.ciudad}
                    onChange={handleChange}
                    required
                />

                {/* Dirección Input */}
                <AppInput
                    label="Dirección"
                    name="direccion"
                    placeholder="Calle, número..."
                    value={formData.direccion}
                    onChange={handleChange}
                    required
                />
            </div>

            {/* Footer Buttons */}
            <div className="flex items-center justify-end gap-3 mt-6 pt-4 border-gray-100">
                <button
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
                >
                    Descartar
                </button>
                <AppButton
                    title="Guardar cambios"
                    disabled={!isFormValid}
                    style={{
                        backgroundColor: isFormValid ? '#568C13' : undefined,
                    }}
                    onClick={handleSubmit}
                />
            </div>
        </div>
    )
}

export default AddWarehouseForm
